var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"checkbox mr-1",on:{"click":_vm.toggle}},[(_vm.isChecked)?_c('Checked'):_c('Unchecked')],1)}
var staticRenderFns = []

export { render, staticRenderFns }